'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function newPoller(poll, interval, callback) {
  var timeout = undefined;
  var alive = true;
  var available = true;
  var makeAvailable = function makeAvailable() {
    available = true;
  };

  function inner() {
    if (available) {
      available = false;
      var p = poll();
      p.then(makeAvailable, makeAvailable);
      callback(p);
    }

    if (alive) {
      timeout = setTimeout(inner, interval);
    }
  }

  inner();
  return function () {
    clearTimeout(timeout);
    alive = false;
    available = false;
  };
}

var Gallup = (function (_EventEmitter) {
  _inherits(Gallup, _EventEmitter);

  function Gallup(fn) {
    _classCallCheck(this, Gallup);

    var interval = arguments.length <= 1 || arguments[1] === undefined ? 1000 : arguments[1];

    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(Gallup).call(this));

    _this2.interval = interval;

    _this2.poll = function () {
      try {
        return Promise.resolve(fn());
      } catch (ex) {
        return Promise.reject(ex);
      }
    };
    return _this2;
  }

  _createClass(Gallup, [{
    key: 'isPolling',
    value: function isPolling() {
      return this.poller != null;
    }
  }, {
    key: 'emitData',
    value: function emitData(data) {
      this.emit('data', data);
    }
  }, {
    key: 'emitError',
    value: function emitError(err) {
      this.emit('error', err);
    }
  }, {
    key: 'start',
    value: function start() {
      var _this = this;

      if (this.poller == null) {
        this.poller = newPoller(this.poll.bind(this), this.interval, function (p) {
          p.then(_this.emitData.bind(_this), _this.emitError.bind(_this));
        });
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.poller != null) {
        this.poller();
        this.poller = null;
      }
    }
  }]);

  return Gallup;
})(_events2.default);

exports.default = Gallup;